import Layout from "@/views/Layout/index.vue";
let addRoutes = [];
export default addRoutes = [
  {
    path: "/chainMange",
    // hidden: false,
    name: "chainMange",
    redirect: "/chainMangeDetail",
    meta: {
      title: "连锁管理"
    },
    component: "layout",
    children: [
      {
        path: "/chainMangeDetail",
        component: "/otcHealth/chainMange/index.vue",
        // hidden: true,
        meta: {
          title: "连锁管理",
          icon: "el-icon-menu"
        }
      }
    ]
  },
  {
    path: "/sensitive",
    // hidden: false,
    name: "Sensitive",
    redirect: "/sensitiveDetail",
    meta: {
      title: "敏感词管理",
      icon: "el-icon-s-release"
    },
    component: "layout",
    children: [
      {
        path: "/sensitiveDetail",
        component: "/otcHealth/sensitive/index.vue",
        // hidden: true,
        meta: {
          title: "敏感词管理"
        }
      }
    ]
  },
  {
    path: "/article",
    // hidden: false,
    name: "Article",
    redirect: "/articleDetail",
    meta: {
      title: "怡成文章库",
      icon: "el-icon-s-management"
    },
    component: "layout",
    children: [
      {
        path: "/articleDetail",
        component: "/otcHealth/article/index.vue",
        // hidden: true,
        meta: {
          title: "怡成文章库"
        }
      }
    ]
  },
  {
    path: "/equipmentModel",
    // hidden: false,
    name: "EquipmentModel",
    redirect: "/equipmentModelDetail",
    meta: {
      title: "设备型号管理",
      icon: "el-icon-s-order"
    },
    component: "layout",
    children: [
      {
        path: "/equipmentModelDetail",
        component: "/otcHealth/equipmentModel/index.vue",
        // hidden: true,
        meta: {
          title: "设备型号管理"
        }
      }
    ]
  },
  {
    path: "/equipment",
    // hidden: false,
    name: "Equipment",
    redirect: "/undistributed",
    meta: {
      title: "设备管理",
      icon: "el-icon-s-cooperation"
      // icon: "https://img-home.csdnimg.cn/images/20220107104621.png"
    },
    component: "layout",
    children: [
      {
        path: "/undistributed",
        component: "/otcHealth/equipment/undistributed.vue",
        // hidden: true,
        meta: {
          title: "未分配"
        }
      },
      {
        path: "/assigned",
        component: "/otcHealth/equipment/assigned.vue",
        // hidden: true,
        meta: {
          title: "已分配"
        }
      }
    ]
  },
  {
    path: "/userMange",
    // hidden: false,
    name: "UserMange",
    redirect: "/userMangeDetail",
    meta: {
      title: "用户管理",
      icon: "el-icon-user-solid"
    },
    component: "layout",
    children: [
      {
        path: "/userMangeDetail",
        component: "/otcHealth/userMange/index.vue",
        // hidden: true,
        meta: {
          title: "用户管理"
        }
      },
      {
        path: "/patientDetails",
        component: "/otcCommon/patientManage/patientDetails.vue",
        hidden: true,
        meta: {
          title: "患者详情",
          guidePath: true,
          jumpPath: "/userMangeDetail"
        }
      },
      {
        path: "/logDetails",
        component: "/otcHealth/userMange/logDetails.vue",
        hidden: true,
        meta: {
          title: "日志详情",
          guidePath: true,
          jumpPath: "/userMangeDetail"
        }
      }
    ]
  },
  {
    path: "/memberBenefits",
    // hidden: false,
    name: "MemberBenefits",
    redirect: "/memberBenefitsDetail",
    meta: {
      title: "福利管理",
      icon: "el-icon-s-goods"
    },
    component: "layout",
    children: [
      {
        path: "/memberBenefitsDetail",
        component: "/otcHealth/memberBenefits/index.vue",
        // hidden: true,
        meta: {
          title: "福利管理"
        }
      }
    ]
  },
  {
    path: "/lifeCircle",
    // hidden: false,
    name: "LifeCircle",
    redirect: "/lifeCircleDetail",
    meta: {
      title: "生活圈管理",
      icon: "el-icon-s-help"
    },
    component: "layout",
    children: [
      {
        path: "/lifeCircleDetail",
        component: "/otcHealth/lifeCircle/index.vue",
        // hidden: true,
        meta: {
          title: "生活圈管理"
        }
      },
      {
        path: "/lifeCircleOne",
        component: "/otcHealth/lifeCircle/detail.vue",
        hidden: true,
        meta: {
          guidePath: true,
          jumpPath: "/lifeCircleDetail",
          title: "生活圈详情"
        }
      }
    ]
  },

  {
    path: "/banner",
    // hidden: false,
    name: "Banner",
    redirect: "/bannerDetail",
    meta: {
      title: "banner管理",
      icon: "el-icon-picture"
    },
    component: "layout",
    children: [
      {
        path: "/bannerDetail",
        component: "/otcHealth/banner/index.vue",
        // hidden: true,
        meta: {
          title: "banner管理"
        }
      }
    ]
  },
  {
    path: "/question",
    // hidden: false,
    name: "Question",
    redirect: "/questionDetail",
    meta: {
      title: "常见问题",
      icon: "el-icon-question"
    },
    component: "layout",
    children: [
      {
        path: "/questionDetail",
        component: "/otcHealth/questions/index.vue",
        // hidden: true,
        meta: {
          title: "常见问题"
        }
      }
    ]
  }
];
